import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { openDialog } from '../../services/redux/savestate/savestate-actions'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks'
import { getSaveState } from '../../services/redux/savestate/savestate-selectors'
import { RouteConstants } from '../../navigation/navigation-types'
import { Button, Stack, Typography } from '@mui/material'

interface BackButtonProps {
    defaultRoute: RouteConstants // If there is no route to go back to, this is the route that will be used
    disabled?: boolean
}

const BackButton: React.FC<BackButtonProps> = ({ defaultRoute, disabled }: BackButtonProps) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const location = useLocation()
    const saveState = useAppSelector(getSaveState)

    const handleNavigation = () => {
        saveState ? (location.key === 'default' ? navigate(defaultRoute) : navigate(-1)) : dispatch(openDialog(-1))
    }

    return (
        <Button variant='outlined' onClick={handleNavigation} disabled={disabled}>
            <Stack direction='row' alignItems='center' justifyContent='center' spacing={2}>
                <ArrowBackIcon />
                <Typography fontWeight={500}>Zpět</Typography>
            </Stack>
        </Button>
    )
}

export default BackButton
